<!-- Modal de seleção de profissionais -->
<app-selecionar-profissionais
  [visible]="modalVisible()"
  (visibleChange)="onModalVisibleChange($event)"
  [medicosSelecionados]="selectedMedicos()"
  (confirmados)="onProfissionaisConfirmados($event)"
/>

<!-- Container de relatório (padrão baixa-manual) -->
<app-relatorio-container
  tituloRelatorio="Relatório por Seleção"
  descricaoRelatorio="Gere relatórios personalizados com campos configuráveis para médicos selecionados."
  categoriaRelatorio="Registro"
  [filtrosTemplate]="filtrosTemplate"
  [pdfBlobs]="pdfBlobs()"
  [pdfFileName]="pdfFileName() ?? (job$ | async)?.fileName ?? 'relatorio-selecao.pdf'"
  [statusPreview]="(isLoading() || isPending) ? 'PENDING' : ((job$ | async)?.status ?? null)"
  [progressoPreview]="(job$ | async)?.progress ?? 0"
  [textoSemDados]="textoSemDados()"
  textoProcessando="Gerando relatório em PDF via Jasper..."
/>

<!-- Template do painel lateral (coluna de filtros do container) -->
<ng-template #filtrosTemplate>
    <div class="flex flex-col gap-5">
        <!-- Fila de Análise -->
        <div>
            <div class="flex items-center justify-between mb-3">
                <h3 class="secao-titulo flex items-center gap-2">
                    <i class="pi pi-users text-slate-400 text-sm" aria-hidden="true"></i>
                    Fila de Análise
                    <span class="text-[10px] font-bold px-2 py-0.5 rounded-full" [class]="selectedMedicos().length > 0 ? 'bg-green-100 text-green-800' : 'bg-slate-100 text-slate-500'">
                        {{ selectedMedicos().length > 0 ? selectedMedicos().length + ' médico(s)' : 'Vazia' }}
                    </span>
                </h3>
            </div>

            <app-selecao-pessoas-painel
                [selecionados]="selectedMedicos()"
                (selecionadosChange)="onFilaAlterada($event)"
                [chave]="chaveDe"
                [nomeDe]="nomeDe"
                [subtituloDe]="subtituloDe"
                [fotoDe]="fotoDe"
                [ordenacoes]="ordenacoesMedicos"
                rotuloVazio="Nenhum médico selecionado. Use Adicionar para escolher."
                sufixoContador="médico(s) na fila"
                ariaLabelLista="Fila de análise de médicos"
                (abrirSelecao)="abrirModal()"
            />
        </div>

        <!-- Campos do Relatório -->
        <div>
            <div class="flex items-center justify-between mb-3">
                <h3 class="secao-titulo flex items-center gap-2">
                    <i class="pi pi-list-check text-slate-400 text-sm" aria-hidden="true"></i>
                    Campos
                    <span class="text-[10px] font-bold px-2 py-0.5 rounded-full" [class]="selectedFields().length > 0 ? 'bg-green-100 text-green-800' : 'bg-slate-100 text-slate-500'"> {{ selectedFields().length }}/{{ ALL_FIELDS.length }} </span>
                </h3>
                <div class="flex items-center gap-1">
                    <p-button [text]="true" (click)="selecionarTodosCampos()" icon="pi pi-check-square" label="Todos" size="small" [disabled]="availableFields().length === 0" />
                    <p-button [text]="true" severity="danger" (click)="limparCampos()" icon="pi pi-times-circle" label="Nenhum" size="small" [disabled]="selectedFields().length === 0" />
                </div>
            </div>

            <div class="flex flex-col gap-1">
                @for (field of fieldOrder(); track field.id; let i = $index) {
                    @if (camposExpandidos() || i < 3) {
                        @let active = hasField(field.id);
                        <div
                            class="flex items-center gap-2.5 px-3 py-2 rounded-lg border transition-all duration-200 select-none"
                            [class]="active ? 'bg-green-50 border-green-200 shadow-sm hover:bg-green-100/50' : 'bg-slate-50 border-slate-100 hover:bg-white hover:border-slate-200'"
                        >
                            <!-- Setas de reordenação -->
                            <div class="flex flex-col shrink-0 -my-0.5">
                                <button
                                    class="w-4 h-[16px] flex items-center justify-center rounded text-slate-300 hover:text-slate-500 hover:bg-white/80 disabled:opacity-0 transition-all"
                                    (click)="moveUp(i)"
                                    [disabled]="i === 0"
                                    [attr.aria-label]="'Mover ' + field.label + ' para cima'"
                                >
                                    <i class="pi pi-chevron-up text-[8px]" aria-hidden="true"></i>
                                </button>
                                <button
                                    class="w-4 h-[16px] flex items-center justify-center rounded text-slate-300 hover:text-slate-500 hover:bg-white/80 disabled:opacity-0 transition-all"
                                    (click)="moveDown(i)"
                                    [disabled]="i === fieldOrder().length - 1"
                                    [attr.aria-label]="'Mover ' + field.label + ' para baixo'"
                                >
                                    <i class="pi pi-chevron-down text-[8px]" aria-hidden="true"></i>
                                </button>
                            </div>

                            <!-- Badge de posição -->
                            <span class="w-4 h-4 flex items-center justify-center rounded text-[9px] font-bold shrink-0 transition-all duration-200" [class]="active ? 'bg-green-600 text-white' : 'bg-slate-200 text-slate-400'">
                                {{ active ? positionInReport(field.id) : '·' }}
                            </span>

                            <!-- Ícone + rótulo (clicável) -->
                            <div class="flex items-center gap-2 flex-1 min-w-0 cursor-pointer" (click)="toggleField(field)" [attr.aria-label]="(active ? 'Remover ' : 'Incluir ') + field.label">
                                <i [class]="field.icon + ' text-xs shrink-0 transition-colors duration-200 ' + (active ? 'text-green-600' : 'text-slate-400')" aria-hidden="true"></i>
                                <span class="text-xs font-medium transition-colors duration-200 truncate" [class]="active ? 'text-slate-800' : 'text-slate-400'">{{ field.label }}</span>
                            </div>

                            <!-- Toggle -->
                            <p-toggleswitch [ngModel]="active" (ngModelChange)="onFieldToggle(field, $event)" (click)="$event.stopPropagation()" [ariaLabel]="'Incluir ' + field.label + ' no relatório'" class="shrink-0" />
                        </div>
                    }
                }

                <p-button
                    [text]="true"
                    size="small"
                    styleClass="w-full mt-1"
                    [icon]="camposExpandidos() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                    [label]="camposExpandidos() ? 'Mostrar menos' : 'Mostrar mais (' + (fieldOrder().length - 3) + ')'"
                    (click)="camposExpandidos.set(!camposExpandidos())"
                    [ariaLabel]="camposExpandidos() ? 'Recolher campos' : 'Expandir campos'"
                />
            </div>
        </div>

        <!-- Feedback de erro do job -->
        @if (job$ | async; as job) {
            @if (job.status === 'ERROR') {
                <div class="text-red-600 text-sm" role="alert">
                    <i class="pi pi-times-circle mr-1" aria-hidden="true"></i>
                    {{ job.errorMessage ?? 'Erro ao gerar relatório.' }}
                </div>
            }
        }

        <!-- Botões de ação (padrão baixa-manual) -->
        <div class="field pt-5 flex justify-end gap-2">
            <p-button label="Reiniciar" icon="pi pi-refresh" [variant]="'text'" (click)="reiniciar()" />
            <p-button
                label="Exportar CSV"
                icon="pi pi-file-export"
                severity="success"
                [variant]="'text'"
                (click)="exportarCsv()"
                [disabled]="selectedMedicos().length === 0 || selectedFields().length === 0 || isLoading()"
                ariaLabel="Exportar seleção de médicos como CSV"
            />
            <p-button label="Processar Relatório" icon="pi pi-bolt" (click)="processarRelatorio()" [disabled]="selectedMedicos().length === 0 || selectedFields().length === 0 || isLoading() || isPending" [loading]="isLoading() || isPending" />
        </div>
    </div>
</ng-template>
